import { render, staticRenderFns } from "./MainLoading.vue?vue&type=template&id=3a455169&scoped=true"
import script from "./MainLoading.vue?vue&type=script&lang=js"
export * from "./MainLoading.vue?vue&type=script&lang=js"
import style0 from "./MainLoading.vue?vue&type=style&index=0&id=3a455169&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a455169",
  null
  
)

export default component.exports